export default function habitations() {
  function animateWave(id, direction, duration) {
    const pathBase =
      'M36,3C34.5,3,32.7617,3,31,3C27.8694,3,25,3,22,3C19,3,17.1313,3,14,3C10.8694,3,8,3,5,3C3,3,2,3,0,3';

    const pathHover =
      'M36,1.1516C34.4003,0.40258,32.7012,0,30.9395,0C27.8089,0,24.8734,1.27342,22.3457,3.49952C19.8173,5.72563,16.8825,7,13.7512,7C10.6206,7,7.68516,5.72563,5.15742,3.49952C3.57961,2.10999,1.84296,1.09164,0,0.5225';

    const start = $('#' + id).attr('d');

    const finish = direction === 'in' ? pathHover : pathBase;

    KeyshapeJS.animate(
      '#' + id,
      [
        {
          p: 'd',
          t: [0, duration],
          v: ['path("' + start + '")', 'path("' + finish + '")'],
          e: [[0], [0]],
        },
      ],
      { autoremove: false }
    ).range(0, duration);
  }

  $('.habitations__habitation__subtitle').each(function () {
    const id = Math.random().toString(36).substring(10);

    $(this).find('path').attr('id', id);
  });

  $('.habitations__habitation, .habitations__header').each(function () {
    const $img = $(this).find('.habitations__habitation__img');

    const pathId = $(this).find('.habitations__habitation__subtitle path').attr('id');

    $(this)
      .find('.habitations__habitation__title, .habitations__habitation__img, .habitations__habitation__subtitle, .habitations__header__image')
      .hover(
        function () {
          $img.addClass('habitations__habitation__img--hover');
          animateWave(pathId, 'in', 250);
        },
        function () {
          $img.removeClass('habitations__habitation__img--hover');
          animateWave(pathId, 'out', 250);
        }
      );
  });

  $('.habitations__habitation--not-active a').click(function () {
    setTimeout(function () {
      $('.footer__form__short input[type="email"]').focus();
    }, 1000);
  });
}
